// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__31jys","head":"Table_head__3sK9l","col":"Table_col__3Sx3U"};